import React, {FC, ReactNode, useMemo, useState} from 'react'


import {AuthoritiesMap, IAppContext} from "@context/appContext/types/appContext";
import {IAppSettings} from "@baseTypes/appSettings";
import {IUser, IUserBean} from "@containers/user/types/user";
import {IAccount} from "@containers/account/types";

export const AppContext = React.createContext<IAppContext | null>(null)

interface IProps {
    children: ReactNode
}

const appSettings: IAppSettings = (window as any)?.appSettings

const AppContextProvider: FC<IProps> = ({
                                            children,

                                        }) => {



    const [userBean, setUserBean] = useState<IUserBean>(appSettings?.userBean)
    const [user, setUser] = useState<IUser>()
    const [account, setAccount] = useState<IAccount>()

    const [settings, setSettings] = useState(appSettings?.baseSettings)
    const [authorities,setAuthorities] = useState<AuthoritiesMap>({})

    const isMultiAccount:boolean = useMemo(()=>{
       return user?.multiAccount || user?.superTenantAccount || user?.tenantAccount || false
    },[user]);
    return (
        <AppContext.Provider value={{
            user, setUser,
            account, setAccount,
            settings, setSettings,
            userBean, setUserBean,
            isMultiAccount,
            authorities,setAuthorities,
        }}
        >
            {children}
        </AppContext.Provider>
    );
};

export default AppContextProvider;
